import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import { themes } from 'kb-shared';
import moment from 'moment';

export const patientQuery = gql`
  query navigationUser {
    patient {
      id
      firstName
      patientMembership {
        id
        createdAt
        employer
        employerName
        membershipRules {
          code
          id
          discountId
        }
      }
    }
  }
`;

type PatientResponse = {
  patient: {
    id: string;
    firstName: string;
    patientMembership: {
      id: string;
      createdAt: string;
      employer: boolean;
      employerName: string;

      membershipRules: Array<{
        id: string;
        code: string;
        discountId: string;
      }>;
    };
  };
};

type Membership = { createdAt: string; id: string; employer?: boolean; employerName?: string };

const User = () => {
  const { data, loading, error } = useQuery<PatientResponse>(patientQuery);
  const membershipText = (patientMembership: Membership) => {
    if (!patientMembership) {
      return null;
    } else if (patientMembership.employer) {
      return <Membership>{patientMembership.employerName} Member</Membership>;
    } else {
      const date = moment(patientMembership.createdAt).format('MMM YYYY');
      return <Membership>Member Since {date}</Membership>;
    }
  };

  if (loading || error || !data || !data.patient) return <div />;
  const { patientMembership } = data.patient;

  return (
    <Container>
      <Link to="/" className="menu__user__name__container">
        <div className="menu__user__name">
          <div className="h2">{data.patient.firstName}</div>
        </div>
      </Link>
      {membershipText(patientMembership)}
    </Container>
  );
};

type InactiveProps = { inactive?: boolean };

const Membership = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 16px;
  background-color: ${({ inactive }: InactiveProps) =>
    inactive ? themes.colors.gray : themes.colors.beige};
  color: ${themes.colors.KBNight};
  padding: 3px 10px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default User;
